import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import VerticalNameValue from '../../../components/library/layout/VerticalNameValue'
import VerticalNameChildren from '../../../components/library/layout/VerticalNameChildren'
import DateTime from '../../../components/library/common/DateTime'
import Lang from '../../../components/language/services/Lang'
import './TicketBasicInformation.scss'
import ProvinceText from '../../../components/library/common/ProvinceText';
import EmdashText from '../../../components/library/common/EmdashText';
import { useInterviewLabels } from './hooks/useInterviewLabelsHook';
import HomeOfficeIcon from '../../../images/home_office.svg';
import AssignedOfficeIcon from '../../../images/assigned_office.svg';
import ErrorOfficeIcon from '../../../images/error.svg';
import HrbTranslate from 'components/language/HrbTranslate';

const TicketInfo = (props) => {
    const { ticket, lang } = props;
    const [returnTypeStr, setReturnTypeStr] = useState(null)
    const [clientTypeStr, setClientTypeStr] = useState(null)
    const [associateName, setAssociateName] = useState(null)

    const [returnType, clientType, province] = useInterviewLabels(ticket);

    useEffect(() => {
        if (returnType && lang) {
            setReturnTypeStr(Lang.getValue(returnType, lang));
        } else {
            setReturnTypeStr(null);
        }
    }, [returnType, lang])

    useEffect(() => {
        if (clientType && lang) {
            setClientTypeStr(Lang.getValue(clientType, lang));
        } else {
            setClientTypeStr(null);
        }
    }, [clientType, lang])

    useEffect(() => {
        var an = null
        if (ticket) {
            an = ticket.associateName || ticket.associateId || null
        }        
        
        if (an !== associateName) {
            setAssociateName(an)
        }
    }, [ticket])

    return (
        <Fragment>
            <div className='columns tickets'>
                <div className='column is-1' />
                <div className='column is-4'>
                    <VerticalNameValue
                        textKey="Tickets.Labels.Assignee"
                        value={associateName}
                        loading={!ticket} />
                </div>
                <div className='column is-4'>
                    <VerticalNameChildren
                        textKey="Tickets.Labels.HomeOffice"
                        loading={!ticket}>   
                        {ticket &&  !ticket.associateHomeOfficeId &&
                            <div className='ticket-office-info'>
                                <img src={ErrorOfficeIcon} />
                                <p className='p1 medium-weight'>
                                    <HrbTranslate text='Tickets.MissingOffice.MissingOfficeId' className='ticket-office-error'/>
                                </p>
                            </div>
                        }    
                        {ticket &&  ticket.associateHomeOfficeId && !ticket.homeOfficeName &&
                            <div className='ticket-office-info'>
                                <img src={ErrorOfficeIcon} />
                                <p className='p1 medium-weight'> 
                                    <span className='ticket-office-error'>
                                        {`${ticket.associateHomeOfficeId} (${Lang.getValue("Tickets.MissingOffice.InactiveOffice", lang)})`}
                                    </span>
                                </p>
                            </div>
                        }                     
                        {ticket && ticket.associateHomeOfficeId && ticket.homeOfficeName &&
                            <div className='ticket-office-info'>
                                <img src={HomeOfficeIcon} />
                                <p className='ticket-office-info-title p1 medium-weight'>{`${ticket.associateHomeOfficeId} (${ticket.homeOfficeName})`}</p>
                            </div>
                        }
                    </VerticalNameChildren>
                </div>
                <div className='column is-4'>
                    <VerticalNameChildren
                        textKey="Tickets.Labels.AssignedOffice"
                        loading={!ticket}>                        
                        {ticket &&  !ticket.officeId &&
                            <div className='ticket-office-info'>
                                <img src={ErrorOfficeIcon} />
                                <p className='p1 medium-weight'>
                                    <HrbTranslate text='Tickets.MissingOffice.MissingOfficeId' className='ticket-office-error'/>
                                </p>
                            </div>
                        }    
                        {ticket &&  ticket.officeId && !ticket.officeName &&
                            <div className='ticket-office-info'>
                                <img src={ErrorOfficeIcon} />
                                <p className='p1 medium-weight'> 
                                    <span className='ticket-office-error'>
                                        {`${ticket.officeId} (${Lang.getValue("Tickets.MissingOffice.InactiveOffice", lang)})`}
                                    </span>
                                </p>
                            </div>
                        }                     
                        {ticket && ticket.officeId && ticket.officeName &&
                            <div className='ticket-office-info'>
                                <img src={AssignedOfficeIcon} />
                                <p className='ticket-office-info-title p1 medium-weight'>{`${ticket.officeId} (${ticket.officeName})`}</p>
                            </div>
                        }
                    </VerticalNameChildren>
                </div>
            </div>
            <div className='columns tickets'>
                <div className='column is-1' />
                <div className='column is-4'>
                    <VerticalNameChildren
                        textKey="Tickets.Labels.TaxProActivity"
                        loading={!ticket}>
                        {ticket && ticket.lastModifiedByNonTarget &&
                            <p className='p1 medium-weight'><DateTime value={ticket.lastModifiedByNonTarget} dateAndTime/></p>
                        }
                        {(!ticket || !ticket.lastModifiedByNonTarget) &&
                            <p className='p1 medium-weight'><EmdashText /></p>
                        }
                    </VerticalNameChildren>
                </div>
                <div className='column is-4'>
                    <VerticalNameChildren
                        textKey="Tickets.Labels.ClientActivity"
                        loading={!ticket}>
                        {ticket && ticket.lastModifiedByTarget &&
                            <p className='p1 medium-weight'><DateTime value={ticket.lastModifiedByTarget} dateAndTime/></p>
                        }
                        {(!ticket || !ticket.lastModifiedByTarget) &&
                            <p className='p1 medium-weight'><EmdashText /></p>
                        }
                    </VerticalNameChildren>
                </div>
                <div className='column is-2'>
                    <VerticalNameChildren
                        textKey="Account.Labels.ProvinceTerritory"                        
                        loading={!ticket}>
                        <p className='p1 medium-weight'><ProvinceText province={province} /></p>
                    </VerticalNameChildren>
                </div>
                <div className='column is-1' />
            </div>
            <div className='columns tickets'>
                <div className='column is-1' />
                <div className='column is-4'>
                    <VerticalNameChildren
                        textKey="Tickets.Labels.SLACompletionDate"
                        loading={!ticket}>
                        {ticket && ticket.lastModifiedByNonTarget &&
                            <p className='p1 medium-weight'><DateTime value={ticket.lastModifiedByNonTarget} dateAndTime /></p>
                        }
                        {(!ticket || !ticket.lastModifiedByNonTarget) &&
                            <p className='p1 medium-weight'><EmdashText /></p>
                        }
                    </VerticalNameChildren>
                </div>
                <div className='column is-4'>
                    <VerticalNameValue
                        textKey="Tickets.Labels.ReturnType"
                        value={returnTypeStr}
                        loading={!ticket} />
                </div>
                <div className='column is-2'>
                    <VerticalNameValue
                        textKey="Tickets.Labels.Client"
                        value={clientTypeStr}
                        loading={!ticket} />
                </div>
                <div className='column is-1' />
            </div>
        </Fragment>
    );
}

TicketInfo.whyDidYouRender = false;

TicketInfo.propTypes = {
    ticket: PropTypes.object,
    lang: PropTypes.string
}

export default TicketInfo